/* src/app/components/toast/toast.component.scss */
.toast-stack {
  position: fixed;
  z-index: 9999999;
  pointer-events: none;
  display: flex;
  gap: 12px;
}
.toast-stack.bottom {
  left: 50%;
  bottom: 40px;
  transform: translateX(-50%);
  flex-direction: column;
  align-items: center;
}
.toast-stack.bottom .toast-wrapper .toast-card {
  opacity: 0;
  transform: translateY(120px) scale(0.2);
  transition: transform 350ms ease, opacity 200ms ease;
  pointer-events: auto;
}
.toast-stack.bottom .toast-wrapper .toast-card.visible {
  opacity: 1;
  transform: translateY(0) scale(1);
}
.toast-stack.bottom .toast-wrapper .toast-card.removing {
  opacity: 0 !important;
  transform: translateY(120px) scale(0.2) !important;
}
.toast-stack.top {
  left: 50%;
  top: 40px;
  transform: translateX(-50%);
  flex-direction: column-reverse;
  align-items: center;
}
.toast-stack.top .toast-wrapper .toast-card {
  opacity: 0;
  transform: translateY(-120px) scale(0.2);
  transition: transform 350ms ease, opacity 200ms ease;
  pointer-events: auto;
}
.toast-stack.top .toast-wrapper .toast-card.visible {
  opacity: 1;
  transform: translateY(0) scale(1);
}
.toast-stack.top .toast-wrapper .toast-card.removing {
  opacity: 0 !important;
  transform: translateY(-120px) scale(0.2) !important;
}
.toast-stack.left {
  left: 20px;
  top: 60px;
  flex-direction: column-reverse;
  align-items: flex-start;
}
.toast-stack.left .toast-wrapper .toast-card {
  opacity: 0;
  transform: translateX(-240px) scale(0.2);
  transition: transform 350ms ease, opacity 200ms ease;
  pointer-events: auto;
}
.toast-stack.left .toast-wrapper .toast-card.visible {
  opacity: 1;
  transform: translateX(0) scale(1);
}
.toast-stack.left .toast-wrapper .toast-card.removing {
  opacity: 0 !important;
  transform: translateX(-240px) scale(0.2) !important;
}
.toast-stack.right {
  right: 20px;
  top: 60px;
  flex-direction: column-reverse;
  align-items: flex-end;
  pointer-events: auto;
}
.toast-stack.right .toast-wrapper .toast-card {
  opacity: 0;
  transform: translateX(240px) scale(0.2);
  transition: transform 350ms ease, opacity 200ms ease;
}
.toast-stack.right .toast-wrapper .toast-card.visible {
  opacity: 1;
  transform: translateX(0) scale(1);
}
.toast-stack.right .toast-wrapper .toast-card.removing {
  opacity: 0 !important;
  transform: translateX(240px) scale(0.2) !important;
}
.toast-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-width: 260px;
  max-width: 90vw;
  overflow: hidden;
  padding: 0.9rem 1.15rem;
  border-radius: 18px;
  background: rgb(255, 255, 255);
  border-style: solid;
  border-width: 1px 1px 1px 5px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.1);
}
.toast-card.success {
  border-left-color: var(--ion-color-primary);
  color: var(--ion-color-primary);
}
.toast-card.danger {
  border-left-color: var(--ion-color-red);
  color: var(--ion-color-red);
}
.toast-card.warning {
  border-left-color: var(--ion-color-warning);
  color: var(--ion-color-warning);
}
.toast-card .toast-icon {
  font-size: 1.65rem;
  opacity: 0.92;
  flex-shrink: 0;
}
.toast-card .toast-message {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--ion-color-text);
  flex: 1;
  min-width: 0;
}
.toast-card .toast-bg {
  position: absolute;
  inset: 0;
  border-radius: 18px;
  z-index: -1;
  opacity: 1;
  pointer-events: none;
}
:host-context(body.dark) .toast-card {
  background: rgb(22, 28, 36);
  border-top-color: rgba(255, 255, 255, 0.1);
  border-right-color: rgba(255, 255, 255, 0.1);
  border-bottom-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.35);
}
:host-context(body.dark) .toast-card .toast-message {
  color: rgba(255, 255, 255, 0.92);
}
:host-context(body.dark) .toast-progress {
  background: rgba(0, 0, 0, 0.35);
}
.toast-progress {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 5px;
  overflow: hidden;
  border-radius: 0 0 17px 17px;
  background: rgba(13, 18, 24, 0.06);
}
.toast-progress .bar {
  height: 100%;
  width: 100%;
  transform-origin: right;
  transition: transform 50ms linear;
  border-radius: 999px;
  display: flex;
}
.toast-progress .bar.success {
  background: var(--ion-color-primary);
}
.toast-progress .bar.danger {
  background: var(--ion-color-red);
}
.toast-progress .bar.warning {
  background: var(--ion-color-warning);
}
/*# sourceMappingURL=toast.component.css.map */
